import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import './styletwo.css';
import './stylethree.css';
import './CircularProgressBar.css';
import Author from './pages/authanticationpages/author';
import Services from './pages/landingpages/services';
import Blog from './pages/landingpages/blog';
import BlogDetail from './pages/landingpages/blogdetail';
import Faq from './pages/landingpages/faq';
import Signup from './pages/authanticationpages/signup';
import Verify from './pages/authanticationpages/verify';
import Claim from './pages/authanticationpages/claim';
import Success from './pages/authanticationpages/success';
import Home from './pages/landingpages/home';
import Contact from './pages/landingpages/contact';
import Dashboard from './pages/dashboardpages/dashboard';
import Profile from './pages/dashboardpages/profile';
import Propertydetail from './pages/dashboardpages/propertydetail';
import PropertydetailSale from './pages/dashboardpages/propertydetailsSale'
import Properties from './pages/dashboardpages/properties';
import Myinvestment from './pages/dashboardpages/myinvestment';
import Mymarketplace from './pages/dashboardpages/mymarketplace';
import Wallet from './pages/dashboardpages/wallet';
import TopupSuccess from './pages/dashboardpages/topupSuccess';
import BuyPropertySuccess from './pages/dashboardpages/buyPropertySuccess';
import TopupFailer from './pages/dashboardpages/topupFailer';
import PurchaseFailer from './pages/dashboardpages/purchaseFailer.js';
import Wallettwo from './pages/dashboardpages/wallettwo';
import Addmoney from './pages/dashboardpages/addmoney';
import BuyProperty from './pages/dashboardpages/buyproperty';
import Marketplacetwo from './pages/dashboardpages/marketplacetwo';
import Purchaseconfirm from './pages/dashboardpages/purchaseconfirm';
import PurchaseSuccess from './pages/dashboardpages/purchaseSuccess';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import userService from './userService';
import Callback from './callback';
import CallbackLogout from './callbackLogout';
import PrivacyPolicy from './pages/landingpages/privacyPolicy';
import TermsOfUse from './pages/landingpages/termsOfUse';
import Sellingshare from './pages/dashboardpages/sellingshare';

import BowlandForest from './pages/ecovestwelcomepages/Bowland.jsx';
import EcovestEarnXp from './pages/ecovestearnxppages/EarnXp';
import LeaderBoard from './pages/ecovestleaderboardpages/LeaderBoard.jsx';
import EcovestOnboarding from './pages/ecovestonboardingpages/EcovestOnboarding';
import EcovestLoading from './pages/landingpages/ecovestLoading.js';
import { Box, CircularProgress, Typography } from '@mui/material';
import HamsterleyForest from './pages/ecovestwelcomepages/HamsterleyForest.jsx';
import SherwoodForest from './pages/ecovestwelcomepages/SherwoodForest.jsx';

import { AdminAuthProvider } from './admin/context/AdminAuthContext';
import AdminLogin from './admin/pages/AdminLogin';
import AdminLayout from './admin/components/AdminLayout';
import ProtectedAdminRoute from './admin/components/ProtectedAdminRoute';
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminUsers from './admin/pages/AdminUsers';
import PropertiesPage from './admin/pages/properties/PropertiesPage';
import PropertiesTypePage from './admin/pages/properties/PropertiesTypePage';
import AddPropertyPage from './admin/pages/properties/AddPropertyPage';
import EditPropertyPage from './admin/pages/properties/EditPropertyPage';
import PropertyViewPage from './admin/pages/properties/PropertyViewPage';
import AddressesPage from './admin/pages/properties/AddressesPage';
import TagsPage from './admin/pages/properties/TagsPage';
import SectionPage from './admin/pages/properties/SectionPage';
import InvestorPage from './admin/pages/users/InvestorPage';
import InvestorEditPage from './admin/pages/users/InvestorEditPage';
import InvestorPropertiesPage from './admin/pages/users/InvestorPropertiesPage';
import InvestorXpPage from './admin/pages/users/InvestorXpPage';
import InvestorEarnxpPage from './admin/pages/users/InvestorEarnxpPage';
import FavoritePage from './admin/pages/users/FavoritePage';
import PurchaseTransactionsPage from './admin/pages/transactions/PurchaseTransactionsPage';
import TopupTransactionPage from './admin/pages/transactions/TopupTransactionPage';
import WithdrawalTransactionPage from './admin/pages/transactions/WithdrawalTransactionPage';
import ForSalePage from './admin/pages/transactions/ForSalePage';
import CashWalletPage from './admin/pages/transactions/CashWalletPage';
import BlogPage from './admin/pages/content/BlogPage';
import BlogCategoryPage from './admin/pages/content/BlogCategoryPage';
import ContactUsPage from './admin/pages/content/ContactUsPage';
import QuestionPage from './admin/pages/content/QuestionPage';
import QuestionEditPage from './admin/pages/content/QuestionEditPage';
import AnswerInvestorPage from './admin/pages/content/AnswerInvestorPage';
import CountryPage from './admin/pages/system/CountryPage';
import CurrencyPage from './admin/pages/system/CurrencyPage';
import IpLoggingPage from './admin/pages/system/IpLoggingPage';
import TannitIdsPage from './admin/pages/system/TannitIdsPage';
import PruPage from './admin/pages/system/PruPage';
import ForestPage from './admin/pages/ecovest/ForestPage';
import TreePage from './admin/pages/ecovest/TreePage';
import EarnXpPage from './admin/pages/ecovest/EarnXpPage';
import AddressesTrackerPage from './admin/pages/ecovest/AddressesTrackerPage';


function App() {
  const [percentageUser, setPercentageUser] = useState(null);
  const [error, setError] = useState(null);
  const base_Url = process.env.REACT_APP_API_URL;
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const user = useSelector(state => state.auth.user);
  const { id } = user.claims || {};
  const investorId = id && id.toString();
  const handleLogout = () => {
    userService.signoutRedirect();
  };

  if (error) {
    console.log(error.message);
  }
  const fetchPercentage = async () => {
    try {
      const response = await axios.get(`${base_Url}/Progress/${investorId}`);
      setPercentageUser(!response.data.data[0]);
    } catch (error) {
      setError(error);
    }
  };
  fetchPercentage();
  return (
    <div className="App">
      <AdminAuthProvider>
        <Router>
          <Routes>
            <Route path="/faq" element={<Faq />} />
            <Route path="/services" element={<Services />} />
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/author" element={<Author />} />
            <Route path="/propertydetail/:propertyId" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <Propertydetail />} />
            <Route path="/properties" element={!isAuthenticated ? <Navigate to="/login" /> : <Properties />} />
            <Route path="/myinvestment" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <Myinvestment /> } />
            <Route path="/mymarketplace" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <Mymarketplace /> } />
            <Route path="/signup" element={<Signup />} />
            <Route path="/claim" element={<Claim />} />
            <Route path="/success" element={<Success />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/dashboard" element={!isAuthenticated ? <Navigate to="/login" /> : <Dashboard />} />          
            <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/login" />}/>
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/marketplace" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <Marketplacetwo />} />
            <Route path="/marketplacetwo" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <Marketplacetwo />} />
            <Route path="/wallet-two" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <Wallettwo />}/>
            <Route path="/topupSuccess" element={<TopupSuccess /> } />
            <Route path="/buyPropertySuccess" element={<BuyPropertySuccess /> } />
            <Route path="/purchaseSuccess" element={isAuthenticated ? <PurchaseSuccess /> : <Navigate to="/login" />} />
            <Route path="/purchaseconfirm" element={isAuthenticated ? <Purchaseconfirm /> : <Navigate to="/login" />} />
            <Route path="/topupFailer" element={<TopupFailer /> } />
            <Route path="/purchaseFailer" element={<PurchaseFailer /> } />
            <Route path="/addmoney" element={!isAuthenticated ? <Navigate to="/login" /> : <Addmoney /> }/>
            <Route path="/buyproperty" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <BuyProperty /> }/>
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<LogoutButton onLogout={handleLogout} />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/callbackLogout" element={<CallbackLogout />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse  />} />
            <Route path="/selling-share" element={<Sellingshare  />} />
            <Route path="/property-details-sale/:propertyId" element={!isAuthenticated ? <Navigate to="/login" /> : percentageUser ? <Navigate to="/profile" /> : <PropertydetailSale />} />

            <Route path="/Ecovest/Bowland" element={!isAuthenticated ? <Navigate to="/login" /> : <BowlandForest  /> } />
            <Route path="/Ecovest/Hamsterley" element={!isAuthenticated ? <Navigate to="/login" /> : <HamsterleyForest  /> } />
            <Route path="/Ecovest/Sherwood" element={!isAuthenticated ? <Navigate to="/login" /> : <SherwoodForest  /> } />
            <Route path="/Ecovest/EarnXp" element={!isAuthenticated ? <Navigate to="/login" /> : <EcovestEarnXp  /> } />
            <Route path="/Ecovest/LeaderBoard" element={!isAuthenticated ? <Navigate to="/login" /> : <LeaderBoard  /> } />
            <Route path="/Ecovest/Onboarding" element={<EcovestOnboarding  />} />
            <Route path="/Ecovest/Loading" element={<EcovestLoading  />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<ProtectedAdminRoute><AdminLayout /></ProtectedAdminRoute>}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="users" element={<ProtectedAdminRoute superAdminOnly><AdminUsers /></ProtectedAdminRoute>} />
              {/* Properties */}
              <Route path="properties" element={<PropertiesPage />} />
              <Route path="properties/add" element={<AddPropertyPage />} />
              <Route path="properties/edit/:propertyId" element={<EditPropertyPage />} />
              <Route path="properties/view/:propertyId" element={<PropertyViewPage />} />
              <Route path="properties-type" element={<PropertiesTypePage />} />
              <Route path="addresses" element={<AddressesPage />} />
              <Route path="tags" element={<TagsPage />} />
              <Route path="sections" element={<SectionPage />} />
              {/* Users */}
              <Route path="investor" element={<InvestorPage />} />
              <Route path="investor/edit/:investorId" element={<InvestorEditPage />} />
              <Route path="investor-properties" element={<InvestorPropertiesPage />} />
              <Route path="investor-xp" element={<InvestorXpPage />} />
              <Route path="investor-earnxp" element={<InvestorEarnxpPage />} />
              <Route path="favorite" element={<FavoritePage />} />
              {/* Transactions */}
              <Route path="purchase-transactions" element={<PurchaseTransactionsPage />} />
              <Route path="topup-transaction" element={<TopupTransactionPage />} />
              <Route path="withdrawal-transaction" element={<WithdrawalTransactionPage />} />
              <Route path="for-sale" element={<ForSalePage />} />
              <Route path="cash-wallet" element={<CashWalletPage />} />
              {/* Content */}
              <Route path="blog" element={<BlogPage />} />
              <Route path="blog-category" element={<BlogCategoryPage />} />
              <Route path="contact-us" element={<ContactUsPage />} />
              <Route path="question" element={<QuestionPage />} />
              <Route path="question/new" element={<QuestionEditPage />} />
              <Route path="question/:id/edit" element={<QuestionEditPage />} />
              <Route path="answer-investor" element={<AnswerInvestorPage />} />
              {/* System */}
              <Route path="country" element={<CountryPage />} />
              <Route path="currency" element={<CurrencyPage />} />
              <Route path="ip-logging" element={<IpLoggingPage />} />
              <Route path="tannit-ids" element={<TannitIdsPage />} />
              <Route path="pru" element={<PruPage />} />
              {/* EcoVest */}
              <Route path="forest" element={<ForestPage />} />
              <Route path="tree" element={<TreePage />} />
              <Route path="earn-xp" element={<EarnXpPage />} />
              <Route path="addresses-tracker" element={<AddressesTrackerPage />} />
            </Route>
          </Routes>
        </Router>
      </AdminAuthProvider>
    </div>
  );
}

const Login = () => {
  const [isRedirecting, setIsRedirecting] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      userService.signinRedirect();
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  if (isRedirecting) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
      >
        <CircularProgress size={60} />
        <Typography variant="h6" mt={3}>
          Redirecting to login...
        </Typography>
        <Typography variant="body2" mt={2} color="textSecondary">
          Please wait while we take you to the secure login page
        </Typography>
      </Box>
    );
  }

  return null;
};

const LogoutButton = ({ onLogout }) => {
  React.useEffect(() => {
    onLogout();
  }, [onLogout]);

  return <Navigate to="/" />;
};

export default App;
